import axios from "axios";
import React from "react";
import { useForm } from "react-hook-form";
import Resizer from "react-image-file-resizer";

const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      500,
      "auto",
      "JPEG",
      55,
      0,
      (uri) => {
        resolve(uri);
      },
      "base64"
    );
  });

const dataURIToBlob = (dataURI) => {
  const splitDataURI = dataURI.split(",");
  const byteString =
    splitDataURI[0].indexOf("base64") >= 0
      ? atob(splitDataURI[1])
      : decodeURI(splitDataURI[1]);
  const mimeString = splitDataURI[0].split(":")[1].split(";")[0];
  const ia = new Uint8Array(byteString.length);
  for (let i = 0; i < byteString.length; i++) ia[i] = byteString.charCodeAt(i);
  return new Blob([ia], { type: mimeString });
};

const AddProjects = () => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const onSubmit = async (data) => {
    const file = data.img[0];
    const image = await resizeFile(file);
    const newFile = dataURIToBlob(image); //optional for uploading

    const formData = new FormData();
    formData.append("name", data.name);
    formData.append("img", newFile);
    formData.append("liveServer", data.liveServer);
    formData.append("codeLink", data.codeLink);
    formData.append("usedTech", data.usedTech);
    formData.append("category", data.category);
    formData.append("description", data.description);

    axios
      .post("https://infinite-cliffs-70499.herokuapp.com/projects", formData)
      .then((res) => {
        if (res.data.insertedId) {
          alert("product added");
          reset();
        }
      });
  };
  return (
    <div>
      <form
        className="md:w-1/2 space-y-3 mt-4 mx-auto"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div>
          <label className="text-white" htmlFor="">
            Enter Project name
          </label>
          <input
            className="w-full p-2  text-black"
            {...register("name", { required: true })}
          />
          {errors.name && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>

        <div>
          <label className="text-white" htmlFor="">
            Live server
          </label>
          <input
            className="w-full p-2 text-black"
            {...register("liveServer", { required: true })}
          />
          {errors.liveServer && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>
        <div>
          <label className="text-white" htmlFor="">
            Code Link
          </label>
          <input
            className="w-full p-2 text-black"
            {...register("codeLink", { required: true })}
          />
          {errors.codeLink && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>
        <div>
          <label className="text-white" htmlFor="">
            Used Technology
          </label>
          <input
            className="w-full p-2 text-black"
            {...register("usedTech", { required: true })}
          />
          {errors.usedTech && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>
        <div>
          <label className="text-white" htmlFor="">
            Image
          </label>
          <input
            type="file"
            className="w-full p-2 text-black bg-white"
            {...register("img", { required: true })}
          />
          {errors.img && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>
        <div>
          <label className="text-white" htmlFor="">
            Choose Category
          </label>
          <select
            className="w-full p-2 text-black"
            {...register("category", { required: true })}
          >
            <option value="">pick category</option>
            <option value="webApp">Web Application</option>
            <option value="nativeApp">Mobile Application</option>
          </select>
          {errors.category && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>
        <div>
          <label className="text-white" htmlFor="">
            Enter Project Description
          </label>
          <textarea
            rows="7"
            className="w-full p-2  text-black"
            {...register("description", { required: true })}
            placeholder="use ./n for line gap"
          />
          {errors.description && (
            <span className="text-red-600">This field is required &#8727;</span>
          )}
        </div>

        <input className="text-black px-5 py-2" type="submit" />
      </form>
    </div>
  );
};

export default AddProjects;
